import { Plus, X, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const DEFAULT = { enabled: false, interval: 30, advance_days: 60, auto_confirm: false, max_party: 12, windows: [] };

export function ReservationSettings({ value, onChange }) {
  const cfg = { ...DEFAULT, ...(value || {}) };
  const set = (patch) => onChange({ ...cfg, ...patch });
  const setWin = (i, k, v) => set({ windows: cfg.windows.map((w, idx) => (idx === i ? { ...w, [k]: v } : w)) });
  return (
    <div className="rounded-2xl mo-card p-6" data-testid="reservations-card">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl bg-[#5aa469]/12 flex items-center justify-center shrink-0"><CalendarDays className="h-5 w-5 text-[#4a8a56]" /></div>
        <div className="flex-1 space-y-4">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h3 className="font-display font-semibold text-xl">Prenotazione tavoli</h3>
              <p className="text-sm text-gray-600 mt-1">I clienti prenotano un tavolo dal menù scegliendo giorno, orario e persone, anche settimane o mesi prima. Le trovi nel Calendario.</p>
            </div>
            <Switch checked={cfg.enabled} onCheckedChange={(v) => set({ enabled: v, windows: v && cfg.windows.length === 0 ? [{ start: "12:00", end: "14:00" }, { start: "19:00", end: "22:00" }] : cfg.windows })} data-testid="res-enabled-switch" />
          </div>
          {cfg.enabled && (
            <div className="space-y-4" data-testid="res-config">
              <div className="grid sm:grid-cols-3 gap-4">
                <div><Label>Intervallo orari (min)</Label><Input type="number" min="15" max="120" step="15" value={cfg.interval} onChange={(e) => set({ interval: Number(e.target.value) || 30 })} className="mt-1.5 h-11 rounded-lg" data-testid="res-interval" /></div>
                <div><Label>Prenotabile fino a (giorni)</Label><Input type="number" min="1" max="365" value={cfg.advance_days} onChange={(e) => set({ advance_days: Number(e.target.value) || 60 })} className="mt-1.5 h-11 rounded-lg" data-testid="res-advance" /><p className="text-xs text-gray-400 mt-1">Es. 60 = fino a due mesi prima.</p></div>
                <div><Label>Max persone per prenotazione</Label><Input type="number" min="1" max="100" value={cfg.max_party} onChange={(e) => set({ max_party: Number(e.target.value) || 12 })} className="mt-1.5 h-11 rounded-lg" data-testid="res-max-party" /></div>
              </div>
              <label className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 p-3 text-sm">
                <span><strong>Conferma automatica</strong><br /><span className="text-gray-500">Se attiva, la prenotazione è confermata subito quando i posti totali dei tuoi tavoli bastano per quell'orario; altrimenti resta "in attesa" finché non la confermi tu dal Calendario.</span></span>
                <Switch checked={cfg.auto_confirm} onCheckedChange={(v) => set({ auto_confirm: v })} data-testid="res-auto-confirm" />
              </label>
              <div>
                <Label>Orari prenotabili</Label>
                <div className="mt-2 space-y-2">
                  {cfg.windows.map((w, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <Input type="time" value={w.start} onChange={(e) => setWin(i, "start", e.target.value)} className="h-10 w-32" data-testid={`res-win-start-${i}`} /><span className="text-gray-400">–</span>
                      <Input type="time" value={w.end} onChange={(e) => setWin(i, "end", e.target.value)} className="h-10 w-32" data-testid={`res-win-end-${i}`} />
                      <Button variant="ghost" size="icon" onClick={() => set({ windows: cfg.windows.filter((_, j) => j !== i) })} data-testid={`res-win-remove-${i}`}><X className="h-4 w-4 text-red-500" /></Button>
                    </div>
                  ))}
                  <Button variant="outline" size="sm" onClick={() => set({ windows: [...cfg.windows, { start: "19:00", end: "22:00" }] })} className="rounded-full border-dashed bg-white" data-testid="res-win-add"><Plus className="h-4 w-4 mr-1" />Aggiungi fascia</Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
